import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class TodoHistoryDetails extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            history: ''
        };
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    getTodoDetails() {
        fetch(this.state.apiUrl + '/TodoRest/Historydetails/id/' + this.props.match.params.todoId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                this.setState({
                    history:responseJson.history,
                   
                }) 
        })
    }

    componentDidMount()
    {
        document.title = "Intranet | To Do History";
        this.getTodoDetails();
    }

    render() {
        if(this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
        }
        return (
            <div >
            <Header brecum_name="To Do" brecum_page="To Do History"/>
            <div class="right_col">
                <div className="intranet_body">
                <div class="title mob"><HeaderMob page_name="To Do History"/></div>
                <div class="row">
                    <div class="col-md-3 col-xs-12"><b>To Do ID </b></div>
                    <div class="col-md-6 col-xs-12">{this.state.history.object_id}</div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-md-3 col-xs-12"><b>Revision </b></div>
                    <div class="col-md-6 col-xs-12">{this.state.history.created_date} By {this.state.history.user_name}</div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-md-3 col-xs-12"><b>{this.state.history.field} => {this.state.history.action}</b></div>
                    <div class="details_des col-md-6"><div dangerouslySetInnerHTML={{__html:this.state.history.object_content}} /></div>
                </div>
                <div class="top-row border-bottom hidden-xs">
                <Link to={`/todos/`} name={"max"}> <button className="btn btn-blue hidden-sm" >Back</button></Link>
                </div>
                </div>
            </div>
            </div>
            
                );
    }
}

export default TodoHistoryDetails;


// WEBPACK FOOTER //
// ./src/components/todo/todoHistoryDetails.js